
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal-info-form",
      function () {
        return require("private-next-pages/personal-info-form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal-info-form"])
      });
    }
  